import React, { Component } from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';
import utilFunction from '../../containers/function';
import $ from 'jquery';

class WaitingTimesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 10,
      loadingPage: false
    }
  }

  handleScroll = async event => {
    if (this.props.data && this.props.data.length>0 && 
      this.state.page < (this.props.data.length/this.state.pageSize) && 
      !this.state.loadingPage) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight - 20;
      if (scroll >= max) {
        this.state.loadingPage = true;
        this.setState({ loadingPage: true });        
        setTimeout(() => { 
          this.setState({ page: this.state.page + 1, loadingPage: false });
        }, 500);
      }
    } 
  };

  componentDidUpdate(prevProps, prevState) {
    if(JSON.stringify(prevProps.startHourFilter)!=JSON.stringify(this.props.startHourFilter) ||
      JSON.stringify(prevProps.waitingLengthFilter)!=JSON.stringify(this.props.waitingLengthFilter)) {
      $(".waiting-times-table").scrollTop(0);
      this.setState({ page: 1 });
    }
  }

  render() {
    return (
      <section className="waiting-times-table" onScroll={this.handleScroll}>
        <table>
          <thead>
            <tr>
              <th className="waiting-times-table-th date-th" />
              <th className="waiting-times-table-th info-th" />
              <th className="waiting-times-table-th length-th" />
            </tr>
          </thead>
          <tbody>
            {this.props.data &&
              this.props.data
                .filter((item) => {
                  if (
                    (this.props.startHourFilter[0] == '' || this.props.startHourFilter[0] == item.initHour) &&
                    (this.props.waitingLengthFilter[0] == '' ||
                      (this.props.waitingLengthFilter[1] == '' &&
                        item.waitingTime >= this.props.waitingLengthFilter[0]) ||
                      (item.waitingTime >= this.props.waitingLengthFilter[0] &&
                        item.waitingTime < this.props.waitingLengthFilter[1]))
                  ) {
                    return true;
                  }
                  return false;
                })
                .map((item, i) => {
                  if(i>=this.state.page*this.state.pageSize) {
                    return null
                  }
                  return (
                    <tr key={`t-waiting-times-table-${i}`}>
                      <td className="waiting-times-table-td date-td">
                        {utilFunction.getFormatFunction({ type: 'DATE_TIME_PARSE_ISO', format: '%d/%m' })(
                          item.fromDate
                        )}
                      </td>
                      <td className="waiting-times-table-td info-td">
                        <div className="info-place">
                          <span>
                            {this.props.language.detail_waiting_times.table.place.toUpperCase() + ': '}
                          </span>
                          {item.client}
                        </div>
                        <div className="info-vehicle">
                          <span>
                            {this.props.language.detail_waiting_times.table.vehicle.toUpperCase() + ': '}
                          </span>
                          {item.vehicleCode}
                        </div>
                        <div className="info-date info-from">
                          <span>
                            {this.props.language.detail_waiting_times.table.from.toUpperCase() + ': '}
                          </span>
                          {utilFunction.getFormatFunction({
                            type: 'DATE_TIME_PARSE_ISO',
                            format: '%d/%m - %I:%M %p'
                          })(item.fromDate)}
                        </div>
                        <div className="info-date info-to">
                          <span>{this.props.language.detail_waiting_times.table.to.toUpperCase() + ': '}</span>
                          {utilFunction.getFormatFunction({
                            type: 'DATE_TIME_PARSE_ISO',
                            format: '%d/%m - %I:%M %p'
                          })(item.untilDate)}
                        </div>
                      </td>
                      <td className="waiting-times-table-td length-td">
                        {utilFunction.getFormatFunction({
                          type: 'NUMBER',
                          format: 'hh:mm',
                          factor: 1 / 60
                        })(item.waitingTime)}
                      </td>
                    </tr>
                  );
                }
            )}
          </tbody>
        </table>
        {this.state.loadingPage && (
          <div className="loading-table">
            <h6>
              <i className="fas fa-spinner fa-spin" />
            </h6>
          </div>
        )}
      </section>
    );
  }
}

export default WaitingTimesTable;



// WEBPACK FOOTER //
// ./source/client/components/detail_waiting_times/waitingTimesTable.jsx